"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const HBIcon_1 = __importDefault(require("../components/HBIcon/HBIcon"));
function TwoStars18Svg(props) {
    return react_1.default.createElement("svg", Object.assign({ width: 18, height: 19, viewBox: "0 0 18 19", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
        react_1.default.createElement("g", { id: "Stars" },
            react_1.default.createElement("path", { id: "Subtract", d: "M6 5.94679C9.10178 5.56008 11.5602 3.10173 11.9471 0H12.0533C12.4401 3.1016 14.8984 5.55987 18 5.94675V6.05291C14.8982 6.43981 12.4398 8.89843 12.0532 12.0004H11.9472C11.5606 8.8983 9.10202 6.43961 6 6.05286L6 5.94679Z", fill: "#11768D" }),
            react_1.default.createElement("path", { id: "Subtract_2", d: "M0 14.9645C2.06785 14.7067 3.70683 13.0678 3.96474 11H4.03552C4.29342 13.0677 5.93227 14.7066 8 14.9645V15.0353C5.93211 15.2932 4.29317 16.9323 4.03546 19.0002H3.9648C3.70708 16.9322 2.06801 15.2931 3.08866e-09 15.0352L0 14.9645Z", fill: "#5E30E3" })));
}
function TwoStars18(_a) {
    var { svgProps } = _a, props = __rest(_a, ["svgProps"]);
    return react_1.default.createElement(HBIcon_1.default, Object.assign({}, props),
        react_1.default.createElement(TwoStars18Svg, Object.assign({}, svgProps)));
}
exports.default = TwoStars18;
//# sourceMappingURL=TwoStars18.js.map